const translations = require('../../assets/configs/babel/en.json')

// sometimes webpacker in production doesn't rebulild babel
const forceRebuildToken = '2' // eslint-disable-line

window.__localization = {
  locale: 'en',
  translations: translations
}
